import { Undo } from '@naker/design/Services/undo';
import { assetPicker } from '@naker/design/Pickers/assetPicker';
import { colorPicker } from '@naker/design/Pickers/colorPicker';
import { removeQuote } from '@naker/services/Viewer/viewer';

import { Environment, environmentInterface } from '../../viewer/environment';
import { Particle, particleInterface } from '../../viewer/particle';
import { backInterface } from '../../viewer/back';

import merge from 'lodash/merge';

export class BackUndo extends Undo {

    environment: Environment;
    particle: Particle;

    constructor(environment: Environment, particle: Particle) {
        super();
        this.environment = environment;
        this.particle = particle;
    }

    getProjectJsonWithAsset(): backInterface {
        let particleOption: particleInterface = this.particle.getOptions();
        let environmentOption: environmentInterface = this.environment.getOptions();
        let json: backInterface = { environment: environmentOption, particle: particleOption };
        json.palette = colorPicker.getPalette();
        json.assets = assetPicker.getSavedAssets();
        return json;
    }

    getProjectJson(): backInterface {
        let particleOption: particleInterface = this.particle.getOptions();
        let environmentOption: environmentInterface = this.environment.getOptions();
        let json: backInterface = { environment: environmentOption, particle: particleOption };
        return json;
    }

    getProjectJsonString(options?) {
        let json = this.getProjectRoundedJson();
        if (options) json = merge(json, options);
        let jsonString = JSON.stringify(json);
        return removeQuote(jsonString);
    }
}
